import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DestinationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DestinationQuery = { __typename?: 'Query', destination?: { __typename?: 'DestinationList', items: Array<{ __typename?: 'Destination', id: number, name: string, numberingPlans: Array<{ __typename?: 'NumberingPlan', id: number, prefix: string }> } | null> } | null };


export const DestinationDocument = gql`
    query Destination {
  destination {
    items {
      id
      name
      numberingPlans {
        id
        prefix
      }
    }
  }
}
    `;

/**
 * __useDestinationQuery__
 *
 * To run a query within a React component, call `useDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDestinationQuery(baseOptions?: Apollo.QueryHookOptions<DestinationQuery, DestinationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationQuery, DestinationQueryVariables>(DestinationDocument, options);
      }
export function useDestinationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationQuery, DestinationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationQuery, DestinationQueryVariables>(DestinationDocument, options);
        }
export function useDestinationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DestinationQuery, DestinationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DestinationQuery, DestinationQueryVariables>(DestinationDocument, options);
        }
export type DestinationQueryHookResult = ReturnType<typeof useDestinationQuery>;
export type DestinationLazyQueryHookResult = ReturnType<typeof useDestinationLazyQuery>;
export type DestinationSuspenseQueryHookResult = ReturnType<typeof useDestinationSuspenseQuery>;
export type DestinationQueryResult = Apollo.QueryResult<DestinationQuery, DestinationQueryVariables>;